import { Country } from '@prisma/client';

export const shouldShowTaxClassification = (corporation: {
  incorporationCountry: Country;
}) => {
  return corporation.incorporationCountry === Country.US;
};

export const getComplianceFiscalYearKey = (companyId: number, entityId: number) =>
  `compliance-fiscal-year-${companyId}-${entityId}`;